module.exports = __webpack_public_path__ + "static/media/state.913d24b7.svg";